/**
 * @module Section-Advertisement
 */

import { NavLink } from "react-router-dom";
import { navUrl, publicUrlFor } from "../../../globals/common-functions";
import { route } from "../../../globals/constants";

/**
 * 
 * @returns Markup to show sample advertisement
 */
const SectionContactAdvert = () => {
    return (
        <div className="twm-advertisment" style={{ backgroundImage: `url(${publicUrlFor("images/add-bg.jpg")})` }}>
            <div className="overlay" />
            <div>
                <h3 className="av-title">Ready to Transform?</h3>
                <h4 className="av-title2 mt-5">"Technology is best when it brings people together and solves real problems."</h4>
                <p>Let's discuss how the right technology solutions can streamline your operations, reduce costs, and accelerate your business growth.</p>
                <NavLink to={navUrl.pages(route.pages.ABOUT)} className="site-button on-bg">
                    Learn About Us
                    <i className="fa fa-arrow-right" />
                </NavLink>
            </div>
        </div>
    )
}

export default SectionContactAdvert;